(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('cart-extra-features')) {
    class CartExtraFeatures extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.target = Number(this.dataset.target) || 0;
        this.currency = this.dataset.currency || 'BRL';
        this.locale = this.dataset.locale || 'pt-BR';
        this.root = window.Shopify?.routes?.root || '/';

        if (!this.root.endsWith('/')) {
          this.root += '/';
        }

        this.form = this.querySelector('.cart-extra__discount-form');
        this.input = this.querySelector('.cart-extra__discount-input');
        this.button = this.querySelector('.cart-extra__discount-button');
        this.feedback = this.querySelector('.cart-extra__feedback');
        this.applied = this.querySelector('.cart-extra__applied');
        this.removeButton = this.querySelector('.cart-extra__remove');

        this.handleSubmit = this.applyDiscount.bind(this);
        this.handleRemove = this.removeDiscounts.bind(this);
        this.handleCartChange = this.scheduleRefresh.bind(this);

        this.form?.addEventListener('submit', this.handleSubmit);
        this.removeButton?.addEventListener('click', this.handleRemove);

        document.addEventListener('cart:updated', this.handleCartChange);
        document.addEventListener('cart:change', this.handleCartChange);

        this.positionNearCheckout();
        this.refresh();

        const summary = this.closest('.cart-page__summary');

        if (summary) {
          this.observer = new MutationObserver(() => {
            if (!this.isConnected) return;
            this.positionNearCheckout();
          });

          this.observer.observe(summary, {
            childList: true,
            subtree: true
          });
        }
      }

      disconnectedCallback() {
        if (this.isConnected) return;

        this.form?.removeEventListener('submit', this.handleSubmit);
        this.removeButton?.removeEventListener('click', this.handleRemove);
        document.removeEventListener('cart:updated', this.handleCartChange);
        document.removeEventListener('cart:change', this.handleCartChange);

        this.observer?.disconnect();
        clearTimeout(this.refreshTimer);
        this.initialized = false;
      }

      positionNearCheckout() {
        const summary = this.closest('.cart-page__summary');
        if (!summary) return;

        const checkout = summary.querySelector(
          'button[name="checkout"], input[name="checkout"], ' +
          '.cart-summary__checkout-button, ' +
          '.cart__checkout-button, ' +
          'a[href*="/checkout"]'
        );

        if (!checkout) return;

        let anchor = checkout.closest('form') || checkout;

        if (anchor.contains(this)) return;

        // Não introduz um formulário de desconto
        // dentro do formulário de checkout.
        if (anchor.tagName !== 'FORM') {
          const formParent = anchor.closest('form');
          if (formParent) anchor = formParent;
        }

        if (this.parentElement === anchor.parentElement &&
            this.nextElementSibling === anchor) {
          return;
        }

        // Evita inserir a barra dentro de seus
        // próprios elementos ou de outros formulários.
        const destination = anchor.parentElement;

        if (!destination || this.contains(destination)) return;

        this.observer?.disconnect();

        destination.insertBefore(this, anchor);

        const summaryRoot = this.closest('.cart-page__summary');

        if (this.observer && summaryRoot) {
          this.observer.observe(summaryRoot, {
            childList: true,
            subtree: true
          });
        }
      }

      formatMoney(cents) {
        const amount = cents / 100;

        try {
          return new Intl.NumberFormat(
            this.locale.replace('_', '-'),
            {
              style: 'currency',
              currency: this.currency
            }
          ).format(amount);
        } catch (error) {
          return `${this.currency} ${amount.toFixed(2)}`;
        }
      }

      async getCart() {
        const response = await fetch(`${this.root}cart.js`, {
          credentials: 'same-origin',
          cache: 'no-store'
        });

        if (!response.ok) {
          throw new Error('Não foi possível consultar o carrinho.');
        }

        return response.json();
      }

      updateShipping(cart) {
        const bar = this.querySelector('.cart-extra__progress');
        const fill = this.querySelector('.cart-extra__progress-fill');
        const message = this.querySelector('.cart-extra__shipping-message');
        const percentage = this.querySelector('.cart-extra__percentage');

        if (!bar || !fill || !message || !this.target) return;

        const total = Number(cart.total_price) || 0;
        const remaining = Math.max(this.target - total, 0);
        const progress = Math.min(
          Math.max(total / this.target * 100, 0),
          100
        );

        fill.style.width = `${progress}%`;
        bar.setAttribute('aria-valuenow', String(Math.round(progress)));

        message.replaceChildren();

        if (remaining === 0) {
          message.textContent =
            this.dataset.shippingSuccess || 'Você atingiu o frete grátis!';
        } else {
          const prefix = document.createTextNode(
            `${this.dataset.shippingPrefix || 'Faltam apenas'} `
          );

          const amount = document.createElement('strong');
          amount.textContent = this.formatMoney(remaining);

          const suffix = document.createTextNode(
            ` ${this.dataset.shippingSuffix || 'para ganhar frete grátis!'}`
          );

          message.append(prefix, amount, suffix);
        }

        if (percentage) {
          percentage.textContent = `${Math.round(progress)}%`;
        }
      }

      getDiscountCodes(cart) {
        if (!Array.isArray(cart.discount_codes)) return [];

        return cart.discount_codes
          .map((item) => typeof item === 'string' ? item : item.code)
          .filter(Boolean);
      }

      updateDiscounts(cart) {
        if (!this.applied) return;

        const codes = [...new Set(this.getDiscountCodes(cart))];

        this.applied.replaceChildren();

        for (const code of codes) {
          const tag = document.createElement('span');
          tag.className = 'cart-extra__tag';
          tag.textContent = code;
          this.applied.appendChild(tag);
        }

        if (this.removeButton) {
          this.removeButton.hidden = codes.length === 0;
        }
      }

      async refresh() {
        try {
          const cart = await this.getCart();

          if (!this.isConnected) return;

          this.updateShipping(cart);
          this.updateDiscounts(cart);
        } catch (error) {
          console.error('[Cart Extra Features]', error);
        }
      }

      scheduleRefresh() {
        clearTimeout(this.refreshTimer);

        this.refreshTimer = setTimeout(() => {
          if (this.isConnected) this.refresh();
        }, 450);
      }

      setFeedback(message, status = '') {
        if (!this.feedback) return;
        this.feedback.textContent = message;
        this.feedback.dataset.status = status;
      }

      async updateDiscountCode(value) {
        const response = await fetch(`${this.root}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ discount: value })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'Não foi possível atualizar o cupom.'
          );
        }

        return result;
      }

      async applyDiscount(event) {
        event.preventDefault();

        const code = this.input?.value.trim();

        if (!code) {
          this.setFeedback('Digite um código de desconto.', 'error');
          return;
        }

        this.button.disabled = true;
        this.setFeedback('Aplicando cupom...');

        try {
          const previousCart = await this.getCart();
          const existingCodes = this.getDiscountCodes(previousCart);

          if (existingCodes.some(
            (item) => item.toLowerCase() === code.toLowerCase()
          )) {
            this.setFeedback('Este código já foi adicionado.', 'error');
            return;
          }

          const updatedCart = await this.updateDiscountCode(
            [...existingCodes, code].join(',')
          );

          this.updateShipping(updatedCart);
          this.updateDiscounts(updatedCart);

          const registered = this.getDiscountCodes(updatedCart)
            .some((item) => item.toLowerCase() === code.toLowerCase());

          if (!registered) {
            this.setFeedback(
              'Não foi possível confirmar o cupom. Confira as condições do desconto.',
              'error'
            );
            return;
          }

          const details = updatedCart.discount_codes?.find(
            (item) => item.code?.toLowerCase() === code.toLowerCase()
          );

          if (details?.applicable === false) {
            this.setFeedback(
              'Código registrado, mas não aplicável a este carrinho.',
              'error'
            );
            return;
          }

          this.setFeedback('Cupom registrado!', 'success');
          window.location.reload();

        } catch (error) {
          this.setFeedback(
            error.message || 'Erro ao aplicar cupom.',
            'error'
          );
        } finally {
          if (this.isConnected) this.button.disabled = false;
        }
      }

      async removeDiscounts() {
        if (!this.removeButton) return;

        this.removeButton.disabled = true;
        this.setFeedback('Removendo cupons...');

        try {
          await this.updateDiscountCode('');
          window.location.reload();
        } catch (error) {
          this.setFeedback(
            error.message || 'Erro ao remover cupons.',
            'error'
          );
          this.removeButton.disabled = false;
        }
      }
    }

    customElements.define('cart-extra-features', CartExtraFeatures);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
